import { createSelector } from 'reselect';
import { getScrollState } from 'src/modules/scroll/selectors/getScrollState';

export const getScrollRestoration = createSelector([
  getScrollState,
], (state) => state.scrollRestoration);
